import React from 'react';
import { Table, Button, Space, Typography } from 'antd';
import { EyeOutlined, DeleteOutlined, PrinterOutlined, DownloadOutlined, MailOutlined } from '@ant-design/icons';

const { Text } = Typography;

const RockNMaltaTab = ({ 
  applications, 
  loading, 
  canDelete,
  onRefresh, 
  onView, 
  onPrint, 
  onDelete,
  onExportCSV,
  onEmailTemplatesClick,
  formatDate 
}) => {
  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 80,
      responsive: ['sm']
    },
    {
      title: 'Organisation',
      dataIndex: 'organisation_name',
      key: 'organisation_name',
      render: (text) => <Text strong>{text}</Text>,
      ellipsis: true,
      responsive: ['xs']
    },
    {
      title: 'Applicant',
      dataIndex: 'applicant_name',
      key: 'applicant_name',
      responsive: ['md'],
      ellipsis: true
    },
    {
      title: 'Email',
      dataIndex: 'email_address',
      key: 'email_address',
      responsive: ['lg'],
      ellipsis: true
    },
    {
      title: 'Submitted',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (date) => formatDate(date),
      responsive: ['md'],
      width: 120
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Space direction="vertical" size="small">
          <Button
            type="primary"
            icon={<EyeOutlined />}
            onClick={() => onView(record.id)}
            size="small"
            block
          >
            View
          </Button>
          <Button
            icon={<PrinterOutlined />}
            onClick={() => onPrint(record)}
            size="small"
            block
          >
            Print
          </Button>
          {canDelete && (
            <Button
              danger
              icon={<DeleteOutlined />}
              onClick={() => onDelete(record.id)}
              size="small"
              block
            >
              Delete
            </Button>
          )}
        </Space>
      ),
      width: 120,
      fixed: 'right'
    },
  ];

  return (
    <>
      <div style={{ marginBottom: '16px' }}>
        <Space>
          <Button 
            onClick={onRefresh}
            loading={loading}
          >
            Refresh
          </Button>
          <Button 
            icon={<DownloadOutlined />}
            onClick={onExportCSV}
            style={{ 
              backgroundColor: '#52c41a', 
              borderColor: '#52c41a',
              color: 'white'
            }}
          >
            Export CSV
          </Button>
          {onEmailTemplatesClick && (
            <Button 
              icon={<MailOutlined />}
              onClick={onEmailTemplatesClick}
            >
              Email Templates
            </Button>
          )}
          <Text type="secondary">
            Total Applications: {applications.length}
          </Text>
        </Space>
      </div>
      
      <Table
        columns={columns}
        dataSource={applications}
        rowKey="id"
        loading={loading}
        pagination={{
          pageSize: 10,
          showSizeChanger: true,
          showQuickJumper: true,
          showTotal: (total, range) => 
            `${range[0]}-${range[1]} of ${total} applications`,
        }}
        scroll={{ x: true }}
      />
    </>
  );
};

export default RockNMaltaTab;
